<template>
  <BreadCrumb PageTitle="Liste des Bons d'envoie" />
  <ListNotes />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ListNotes from "@/components/Notes/SentNotes/ListNotes.vue";

export default defineComponent({
  name: "ListNotesPage",
  components: {
    BreadCrumb,
    ListNotes,
  },
});
</script>